import React from "react";
import { useLocation } from "react-router-dom";

import { NavGroupWrapper } from "./styled";
import NavLink from "components/ui/NavLink";

/**
 * Parent nav item whose children reveal on hover, rather than sitting
 * permanently expanded (the old NavSubLinkWrapper pattern — always-on
 * indented sub-link). Requested directly: Work Orders should hover off
 * a Maintenance parent (not sit as its own top-level trunk item, since
 * for plan clients a WO is conceptually scoped to its plan), and Mulch
 * Calculator should hover off Locations the same way.
 *
 * `childPaths` forces the flyout open (no hover needed) whenever the
 * current route matches one of them — otherwise landing directly on
 * e.g. /mulch-calculator via a bookmark or refresh would show no
 * indication in the sidebar of where you are until the user hovers.
 */
interface NavLinkGroupProps {
  link?: string;
  icon?: React.ComponentType<any>;
  label: string;
  badge?: number | null;
  childPaths?: string[];
  children: React.ReactNode;
}

const NavLinkGroup: React.FC<NavLinkGroupProps> = ({
  link,
  icon,
  label,
  badge,
  childPaths,
  children,
}) => {
  const pathname = useLocation().pathname;
  const forceOpen = (childPaths || []).some((p) => pathname.startsWith(p));

  return (
    <NavGroupWrapper className={forceOpen ? "force-open" : ""}>
      <NavLink link={link} icon={icon} label={label} badge={badge} />
      <div className="nav-group-children">{children}</div>
    </NavGroupWrapper>
  );
};

export default NavLinkGroup;
